import React from "react";

function Modal({ isOpen, onClose, children }) {
  if (!isOpen) return null;

  return (
    <div className="fixed z-10 inset-0 overflow-y-auto flex items-center justify-center">
      <div className="fixed inset-0 transition-opacity duration-300">
        <div
          className="absolute inset-0 bg-gray-700 opacity-75"
          onClick={onClose}
        ></div>
      </div>

      <div className="overflow-hidden shadow-xl transform transition-all duration-300 min-h-max min-w-[35%] max-w-5xl">
        <div className="">{children}</div>
      </div>
    </div>
  );
}

export default Modal;
